import { storeToRefs } from 'pinia';
import { useUserInfoStore } from '@/modules/shared/stores/userInfo';

const useUserInfo = () => {
    const store = useUserInfoStore();
    const { userInfo } = storeToRefs(store);

    return {
        userInfo
    };
};

export default useUserInfo;
